export default "__VITE_PUBLIC_ASSET__439b1629__"